export function openSideDrawer(data) {
  return {
    type: '@SIDEDRAWER_OPEN',
    payload: data
  };
}

export function closeSideDrawer() {
  return {
    type: '@SIDEDRAWER_CLOSE'
  };
}

export function toggleSideDrawer() {
  return {
    type: '@SIDEDRAWER_TOGGLE'
  };
}

export function changeProtocolCreationLayout() {
  return {
    type: '@CHANGE_PROTOCOL_CREATION_LAYOUT'
  };
}

// criar uma função nova de fechar o modal
export function closeExtraProtocolModal() {
  return {
    type: '@CLOSE_EXTRA_PROTOCOL_MODAL'
  };
}

export function notCloseExtraProtocolModal() {
  return {
    type: '@NOT_CLOSE_EXTRA_PROTOCOL_MODAL'
  };
}
